import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { CALENDLY_URL } from "@/lib/constants";
// Served from public/ so it can be preloaded via <link rel="preload"> in index.html with a stable URL
const heroImg = "/hero-finable.webp";

export default function Hero() {
  return (
    <section id="home" className="relative overflow-hidden bg-gradient-hero text-white pt-32 pb-20 md:pt-40 md:pb-28">
      {/* Aurora blobs */}
      <div className="absolute inset-0 bg-gradient-radial pointer-events-none" />
      <div className="absolute -top-32 -left-32 w-96 h-96 rounded-full bg-accent/20 blur-3xl animate-aurora pointer-events-none" />
      <div className="absolute -bottom-40 -right-20 w-[30rem] h-[30rem] rounded-full bg-accent-glow/15 blur-3xl animate-aurora pointer-events-none" style={{ animationDelay: "4s" }} />

      <div className="container relative grid xl:grid-cols-2 gap-12 items-center">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 backdrop-blur px-4 py-1.5 text-xs font-medium text-white/80 mb-6">
            Effizient · Unabhängig · Digital
          </div>
          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-extrabold leading-[1.05] text-balance">
            <span className="text-accent">Steuern sparen.</span> Staatliche Förderungen sichern. Vermögen aufbauen.
          </h1>
          <p className="mt-6 text-lg md:text-2xl font-medium text-white/90 text-balance">
            <span className="md:hidden">
              Die meisten wissen es nicht mal.
              <br />
              Wir zeigen Dir, wie Du es Dir holst.
            </span>
            <span className="hidden md:inline">Besiege die Inflation und hol Dir die staatlichen Förderungen zur Altersvorsorge, die Du jeden Monat verschenkst.</span>
          </p>
          <p className="mt-4 text-base md:text-lg text-white/70 max-w-xl hidden md:block">
            Als unabhängige Finanzberatung aus Hamburg zeigen wir Dir, wie Du mit steueroptimierter Altersvorsorge, Riester, Rürup, bAV und renditeorientierten ETF-Investments langfristig Vermögen aufbaust – 100 % digital & bundesweit.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <Button asChild variant="hero" size="xl">
              <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer">
                Jetzt Erstgespräch vereinbaren <ArrowRight className="w-4 h-4" />
              </a>
            </Button>
            <Button asChild variant="outlineLight" size="xl">
              <a href="#services">Mehr erfahren</a>
            </Button>
          </div>
        </div>

        <div className="relative hidden xl:block">
          <div className="absolute inset-0 bg-accent/20 blur-3xl rounded-full" />
          <img
            src={heroImg}
            srcSet="/hero-finable-640.webp 640w, /hero-finable-1200.webp 1200w, /hero-finable.webp 1280w"
            sizes="(min-width: 1280px) 600px, 100vw"
            alt="Finable – Finanzberatung Hamburg"
            width={1280}
            height={822}
            loading="eager"
            decoding="async"
            // @ts-expect-error fetchpriority is a valid HTML attr not yet in React types
            fetchpriority="high"
            className="relative rounded-2xl shadow-elegant border border-white/10"
          />
        </div>
      </div>

    </section>
  );
}
